import { string, number } from 'yup';

const MAX_LENGTH = 45;
const PASSWORD_MAX_LENGTH = 128;
const PASSWORD_MIN_LENGTH = 8;
// Accorder to the design that the agency send us
const MIN_WIDTH_DEVICE_SUPPORT = 810;
const MIN_WIDTH_MOBILE_SUPPORT = 550;

// Min and Max user weight in lbs
const MIN_USER_WEIGHT = 50;
const MAX_USER_WEIGHT = 500;

// Min and Max user height in inches
const MIN_USER_HEIGHT = 36;
const MAX_USER_HEIGHT = 96;

const requiredText = 'This field is required';

export const email = async (value) => {
  try {
    await string().trim().required(requiredText).email('The email format is invalid').validate(value);
    return null;
  } catch ({ message }) {
    return message;
  }
};

export const name = async (value) => {
  try {
    await string().trim().max(MAX_LENGTH, '45 characters maximum').required(requiredText).validate(value);
    return null;
  } catch ({ message }) {
    return message;
  }
};

export const userName = async (value) => {
  try {
    await string()
      .trim()
      .max(MAX_LENGTH, '45 characters maximum')
      .matches(/^[a-zA-Z0-9._-]*(?!\s)[a-zA-Z0-9._-]+$/, 'Valid characters are A-Z a-z 0-9 . _ -')
      .required(requiredText)
      .validate(value);
    return null;
  } catch ({ message }) {
    return message;
  }
};

export const password = async (value, isRequired = true) => {
  try {
    if (isRequired) {
      await string()
        .required(requiredText)
        .min(PASSWORD_MIN_LENGTH, 'Password must be at least 8 characters long.')
        .max(PASSWORD_MAX_LENGTH, 'Maximum password length is 128 characters.')
        .validate(value);
    } else {
      await string()
        .min(PASSWORD_MIN_LENGTH, 'Password must be at least 8 characters long.')
        .max(PASSWORD_MAX_LENGTH, 'Maximum password length is 128 characters.')
        .validate(value);
    }
    return null;
  } catch ({ message }) {
    return message;
  }
};

export const text = async (value) => {
  try {
    await string().trim().required(requiredText).validate(value);
    return null;
  } catch ({ message }) {
    return message;
  }
};

export const usaZipCode = async (value) => {
  try {
    await string()
      .trim()
      .matches(/(^\d{5}$)|(^\d{5}-\d{4}$)/, { message: 'This field is required' })
      .required(requiredText)
      .validate(value);
    return null;
  } catch ({ message }) {
    return message;
  }
};

export const userWeight = async (value) => {
  try {
    await number()
      .required()
      .min(MIN_USER_WEIGHT, 'Minimum weight 50 lbs')
      .max(MAX_USER_WEIGHT, 'Maximum weight 500 lbs')
      .validate(value);
  } catch ({ message }) {
    return message;
  }
};

export const userHeight = async (value) => {
  try {
    await number()
      .required()
      .min(MIN_USER_HEIGHT, "Minimum height 3'")
      .max(MAX_USER_HEIGHT, "Maximum height 8'")
      .validate(value);
  } catch ({ message }) {
    return message;
  }
};

export const checkVisible = (element) => {
  const rect = element.getBoundingClientRect();
  const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
  return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
};

export const isBigScreen = () => {
  if (typeof window !== 'undefined') {
    return window.innerWidth > MIN_WIDTH_DEVICE_SUPPORT;
  }
  return false;
};

export const isTablet = () => {
  if (typeof window !== 'undefined') {
    const userAgent = navigator.userAgent.toLowerCase();
    return /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
      userAgent
    );
  }
  return false;
};

export const isAllowedScreenInMobile = () => {
  if (typeof window !== 'undefined') {
    return window.innerWidth > MIN_WIDTH_MOBILE_SUPPORT;
  }
  return false;
};

export const isDesktopDevice = () =>
  !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

export const cardElement = (value) => {
  try {
    if (!value || value?.error) {
      throw value.error;
    }
    return null;
  } catch ({ message }) {
    return message;
  }
};

export const fixImagePosition = () => {
  const FIX_IMG_MIDDLE = 0.15;
  const FIX_IMG_TOP = 0.1;

  const MIN_WIDTH_FIX_IMG_MIDDLE = 1800;

  if (typeof window !== 'undefined') {
    return window.innerWidth > MIN_WIDTH_FIX_IMG_MIDDLE ? FIX_IMG_MIDDLE : FIX_IMG_TOP;
  }

  return FIX_IMG_MIDDLE;
};

export const confirmPassword = async (value, values) => {
  try {
    if (values.password) {
      await string()
        .required(requiredText)
        .matches(new RegExp(values.password), "Confirm Password doesn't match Password field")
        .length(values.password.length, "Confirm Password doesn't match Password field")
        .validate(value);
    }
    return null;
  } catch ({ message }) {
    return message;
  }
};

export const dateValidation = async (value) => {
  try {
    await string().trim().required(requiredText).validate(value);

    return null;
  } catch ({ message }) {
    return message;
  }
};

export const promoCode = async (value) => {
  try {
    await string()
      .trim()
      .matches(/S(03|06|12|24)M.{4,}/g, 'We cannot find that code. Check it and try again.')
      .validate(value);
    return null;
  } catch ({ message }) {
    return message;
  }
};
